import React from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { ProgressSpinner } from "primereact/progressspinner";
import {
    genElObject,
    genElText,
} from "../../../components/utils/EditorDialogElementGenerator";
import JenisSelectorDialog from "../../../dialogs/selectors/JenisSelectorDialog";

const editTitle = "Edit Trailer";
const addTitle = "Tambah Trailer";

const TrailerEditorDialog = (props) => {
    const {
        visible,
        onHide,
        onConfirm,
        loading,
        title,
        data,
        setData,
        addNewMode,
        error,
        setError,
    } = props;

    // dialog state
    const [showGrupSelector, setShowGrupSelector] = React.useState(false);
    const [showSupirSelector, setShowSupirSelector] = React.useState(false);
    const [showJenisSelector, setShowJenisSelector] = React.useState(false);
    const [showPemakaianSelector, setShowPemakaianSelector] =
        React.useState(false);

    /**
     * Validates the form data.
     *
     * @returns {boolean} - Returns true if the data is valid, otherwise false.
     * @returns {object} - Returns an object containing the error messages, format { field: message}.
     */
    const validate = () => {
        let valid = true;
        let newEror = {};

        if (!valid) setError(newEror);

        return valid;
    };

    const handleOnClickJenis = () => {
        setShowJenisSelector(true);
    };

    const handleOnConfirmJenis = (event, datas) => {
        let selected;
        event.preventDefault();
        if (datas && datas.length > 0) {
            selected = datas[0];
            setData({
                ...data,
                data_kendaraan_jenis: selected,
                kendaraan_jenis_id: selected.id,
            });
            setShowJenisSelector(false);
        }
        return selected;
    };

    const elJenis = genElObject({
        field: "data_kendaraan_jenis.nama",
        name: "Jenis",
        value: data.data_kendaraan_jenis ? data.data_kendaraan_jenis.nama : "",
        onClick: handleOnClickJenis,
    });
    const elNomor = genElText({
        field: "nomor",
        name: "Nomor",
        data,
        setData,
        error,
    });
    const elKeterangan = genElText({
        field: "keterangan",
        name: "Keterangan",
        data,
        setData,
        error,
    });

    const dialogFooter = (
        <React.Fragment>
            <Button
                label="Cancel"
                icon="pi pi-times"
                outlined
                onClick={props.onHide}
            />
            <Button
                label="Save"
                icon="pi pi-check"
                onClick={(e) => {
                    const valid = validate();
                    if (valid) {
                        onConfirm(data);
                    }
                }}
            />
        </React.Fragment>
    );

    return (
        <Dialog
            visible={visible}
            style={{ width: "45rem" }}
            breakpoints={{ "960px": "75vw", "641px": "90vw" }}
            header={addNewMode ? addTitle : editTitle}
            modal
            className={`p-fluid`}
            footer={dialogFooter}
            onHide={onHide}
        >
            <JenisSelectorDialog
                title={"Pilih Jenis"}
                visible={showJenisSelector}
                onHide={() => setShowJenisSelector(false)}
                onConfirm={handleOnConfirmJenis}
            />

            <div className="col-start-center relative h-100">
                <div className={`col-start-start w-100 gap-3`}>
                    {elJenis}
                    {elNomor}
                    {elKeterangan}
                </div>
                {loading && (
                    <div
                        className={`col-center-center w-100  gap-2 absolute z-100 h-100 bg-black/20 rounded `}
                    >
                        <ProgressSpinner />
                    </div>
                )}
            </div>
        </Dialog>
    );
};

export default TrailerEditorDialog;
